import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "flowbite";
import toast from 'react-hot-toast'
import { useNavigate } from "react-router-dom";

const Support = () => {

    const token = sessionStorage.getItem("bearer_token");
    const auth_token = sessionStorage.getItem("token");
    const [tickets, setTickets] = useState([]);

    const [refreshKey, setRefreshKey] = useState(0);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [ticketId, setTicketId] = useState('');
    const [status, setStatus] = useState('');
    const [comments, setComments] = useState('');

    const [id, setId] = useState('');
    const navigate = useNavigate();

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [permissionModule, setPermissionModule] = useState([]);

    const [filters, setFilters] = useState({
        ticketId: "",
        status: "",
        page: 1,
        limit: 10,
    });
    const [pagination, setPagination] = useState({
        totalRecords: 0,
        currentPage: 1,
        totalPages: 0,
        limit: 0,
    });

    useEffect(() => {
        const getSupportTickets = async () => {

            try {
                const queryParams = Object.entries(filters)
                    .filter(([_, value]) => value) // Only include parameters with non-empty values
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join("&");
                const res = await axios.get(process.env.REACT_APP_API_URL + `api/support/get-support-tickets?${queryParams}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                        "auth_token": `${auth_token}`,
                    },
                });

                if (res.data.success) {
                    setTickets(res.data.tickets);
                    setPagination({
                        totalRecords: res.data.pagination.totalRecords,
                        currentPage: res.data.pagination.currentPage,
                        totalPages: res.data.pagination.totalPages,
                        limit: res.data.pagination.limit,
                    });
                } else {
                    setTickets([]);
                }


            }
            catch (err) {
                if (err.response?.status === 400) {
                    // Handle invalid token error
                    if (err.response.data === "invalid token") {
                        navigate("/login"); // Redirect to login page
                    } else {
                        toast.error(err.response.data); // Show other 400 errors
                    }
                } else {
                    // Handle other errors
                    toast.error("No Tickets Found!");
                }
            }
        }
        getSupportTickets();
        if (permissions) {

            setPermissionModule(permissions.find(
                (permission) => permission.Module.moduleName === 'support'
            ));
        }

    }, [refreshKey, filters]);

    const getTicketData = async (id) => {
        const modalElement = document.getElementById("edit-modal");
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.show();
        }

        try {
            const res = await axios.get(process.env.REACT_APP_API_URL + `api/support/get-support-ticket/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "auth_token": `${auth_token}`,
                },
            });

            setName(res.data.ticket.User.name ?? "");
            setEmail(res.data.ticket.User.email ?? "");
            setPhone(res.data.ticket.User.phone ?? "");
            setTicketId(res.data.ticket.ticketId ?? "");
            setMessage(res.data.ticket.message ?? "");
            setStatus(res.data.ticket.status ?? "");
            setId(id);


        } catch (err) {
            if (err.response?.status === 400) {
                // Handle invalid token error
                if (err.response.data === "invalid token") {
                    navigate("/login"); // Redirect to login page
                } else {
                    toast.error(err.response.data); // Show other 400 errors
                }
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
        }
    }


    useEffect(() => {
        // Initialize the modal on component mount
        const modalElement = document.getElementById("edit-modal");
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.hide(); // Ensure the modal is initially hidden
        }

    }, []);


    // update single admin data
    const handleUpdateTicket = async (e) => {
        e.preventDefault();
        const update_id = id;


        const postData = {
            "status": status,
            "comments": comments
        };

        try {

            const res = await axios.put(process.env.REACT_APP_API_URL + `api/support/update-support-status/${update_id}`, postData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "auth_token": `${auth_token}`,
                },
            });

            if(res.data.success){
                setRefreshKey((prevKey) => prevKey + 1);
                toast.success("Status Updated Successfully!");
            }

        } catch (err) {
            if (err.response?.status === 400) {
                // Handle invalid token error
                if (err.response.data === "invalid token") {
                    navigate("/login"); // Redirect to login page
                } else {
                    toast.error(err.response.data); // Show other 400 errors
                }
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
        }

    };

    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
            page: 1, // Reset to the first page on filter change
        }));
    };

    const handlePageChange = (newPage) => {
        setFilters((prev) => ({ ...prev, page: newPage }));
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString.replace(" ", "T")); // Replace space with T for compatibility
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        const time = date.toLocaleTimeString('en-US', { hour12: false });
        return `${formattedDate} ${time}`;
    };

    const renderStatus = (status) => {
        switch (status) {
            case 'completed':
                return (
                    <p className="bg-[#DEF7EC] text-sm text-[#03543F] px-3 py-1 rounded-full md:w-full text-center">Resolved</p>

                );
            case 'inprogress':
                return (
                    <p className="bg-[#E1EFFE] text-sm text-[#1E429F] px-3 py-1 rounded-full md:w-full text-center">
                        In Progress
                    </p>
                );
            case 'pending':
                return (
                    <p className="bg-gray-200 text-sm text-gray-700 px-3 py-1 rounded-full md:w-full text-center">
                        Pending
                    </p>
                );
            default:
                return (
                    <p className="bg-gray-200 text-sm text-gray-700 px-3 py-1 rounded-full md:w-full text-center">
                        Pending
                    </p>
                );
        }
    }

    return (
        <div className="bg-gray-100">
            <div className="py-20 p-4 sm:ml-64">
                <div className="md:flex justify-between py-5">

                    {/* Filters UI */}
                    <div className=" items-center md:flex gap-4">
                        <input
                            type="text"
                            placeholder="Search by Ticket ID"
                            value={filters.ticketId}
                            onChange={(e) => handleFilterChange("ticketId", e.target.value)}
                            className="my-1 md:my-0 flex border-2 rounded-full px-3 py-2"
                        />

                        <select
                            value={filters.status}
                            onChange={(e) => handleFilterChange("status", e.target.value)}
                            className="my-1 md:my-0 flex border-2 rounded-full px-3 py-2"
                        >
                            <option value="">All Statuses</option>
                            <option value="pending">Pending</option>
                            <option value="inprogress">In Progress</option>
                            <option value="completed">Resolved</option>
                        </select>

                    </div>
                </div>


                <div className="w-full  p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">

                    <div className="flex justify-start">
                        <div className="flex flex-col text-left">
                            <h1 className="text-xl text-black font-bold">Support Tickets</h1>

                        </div>

                    </div>

                    <div className="relative overflow-x-auto custom-scrollbar sm:rounded-lg mt-5">

                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Ticket ID</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">User Name</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">User Email</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Status</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Date/Time</th>
                                    {permissionModule.canUpdate && <th scope="col" className="px-6 py-3 whitespace-normal break-words">View</th>}

                                </tr>
                            </thead>
                            <tbody>
                                {tickets.length > 0 ? (
                                    permissionModule.canRead ? tickets.map((ticket) => (
                                        <tr className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">

                                            <td className="px-6 py-4 whitespace-normal break-words">{ticket.ticketId}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{ticket.User ? ticket.User.name : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{ticket.User ? ticket.User.email : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{renderStatus(ticket.status)}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{formatDate(ticket.createdAt)}</td>
                                            {permissionModule.canUpdate && <td className="px-6 py-4 whitespace-normal break-words"><button type="button" onClick={() => getTicketData(ticket.id)} className="text-white py-1 px-4 bg-black rounded-full">View</button></td>}


                                        </tr>

                                    )) : "Access Denied"
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4 whitespace-normal break-words">No Tickets Found.</td>
                                    </tr>
                                )}

                            </tbody>
                        </table>


                        {/* Pagination */}
                        <div className="flex justify-center my-4">
                            <button
                                onClick={() => handlePageChange(filters.page - 1)}
                                disabled={filters.page === 1}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Previous
                            </button>
                            <span className="px-4 py-2 mx-1 font-medium">
                                Page {pagination.currentPage} of {pagination.totalPages}
                            </span>
                            <button
                                onClick={() => handlePageChange(filters.page + 1)}
                                disabled={filters.page === pagination.totalPages}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            {/* edit modal */}
            <div
                id="edit-modal"
                tabIndex={-1}
                className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
            >
                <div className="relative p-4 w-full max-w-4xl max-h-[60%]">
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <button
                            type="button"
                            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            onClick={() => {
                                const modalElement = document.getElementById("edit-modal");
                                if (modalElement) {
                                    const modal = new Modal(modalElement);
                                    modal.hide();
                                }
                            }}
                        >
                            <svg
                                className="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="p-4  text-center">
                            <div className=" p-6 bg-white shadow rounded-lg">
                                <h2 className="text-2xl font-bold text-center mb-6">Support Ticket</h2>
                                <form onSubmit={handleUpdateTicket}>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-left">

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Ticket ID</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={ticketId}
                                                onChange={(e) => setTicketId(e.target.value)}
                                                disabled
                                            />
                                        </div>



                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">User Name</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                disabled
                                            />
                                        </div>



                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Email</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                disabled
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Phone</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                disabled
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Message</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <textarea className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                disabled
                                            />

                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Comments</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <textarea className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                value={comments}
                                                placeholder="Comments for user (optional)"
                                                onChange={(e) => setComments(e.target.value)}
                                                
                                            />

                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Status</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <select
                                                id="status"
                                                className="w-full p-2 border border-gray-300 rounded"
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                                required
                                            >
                                                <option value="pending">Pending</option>
                                                <option value="completed">Resolved</option>
                                                <option value="inprogress">In Progress</option>
                                            </select>
                                            <p className="mt-2 text-sm">Selected Status: {status || "Pending"}</p>
                                        </div>

                                    </div>

                                    <div className="mt-5 flex justify-end">



                                        <div>

                                            <button
                                                type="submit"
                                                className="text-white bg-black rounded-full text-sm inline-flex items-center px-5 py-2.5 text-center"
                                            >
                                                Save
                                            </button>
                                            <button
                                                onClick={() => {
                                                    const modalElement = document.getElementById("edit-modal");
                                                    if (modalElement) {
                                                        const modal = new Modal(modalElement);
                                                        modal.hide();
                                                    }
                                                }}
                                                type="button"
                                                className="py-2.5 px-5 ms-3 text-sm font-medium text-black focus:outline-none bg-white rounded-full border border-black hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            </div>


                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Support;